import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { formatedNumber } from '../../Functions/convertNumber';
import { formatedDateClient } from '../../Functions/convertDate';
import { exportReservationExcel } from '../../Functions/exportReservation';
import { handlePrint } from '../../Functions/printReservationbrowser';
import  EditReservations  from './editReservation';


import '../../Css/FactureEtablie.css';
import '../../Css/ReservationTable.css';

const ReservationsTable = () => {
    const [reservations, setReservations] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [rowspage, setRowsPage ] = useState(12);
    const [filters, setFilters] = useState({
        startDate: new Date().toISOString().split('T')[0],
        endDate: new Date().toISOString().split('T')[0],
        id_reservation: "",
        organisme: "",
        hotel: "",
        room: "",
        pension: "",
        passport: "",
        clientName: "",
        checkInDate: "",
        checkOutDate: "",
        BCReference: "",
        reservationStatus: "",
    });

    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [selectedReservation, setSelectedReservation] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentPage, setCurrentPage] = useState(0); 

    const token = localStorage.getItem('token'); 
    const apiUrl = process.env.REACT_APP_API_URL;





    const handleFilterChange = useCallback(
        (e) => {
            const { name, value } = e.target;
            setFilters((prev) => ({ ...prev, [name]: value }));
        },
        [setFilters]
    );



              const handleKeyPress = useCallback((event) => {
                if (event.key === 'Enter') {
                  setFilters((prev) => ({ ...prev, date: "" })); 
                  fetchData();
                }
              }, [filters]);
            
              useEffect(() => {
                window.addEventListener('keydown', handleKeyPress);
            
                return () => {
                  window.removeEventListener('keydown', handleKeyPress);
                };
              }, [handleKeyPress]);


        const editReservation = async (reservation_id) => {
            setSelectedReservation(reservation_id); 
            setIsEditModalOpen(true);
        };



        const handleSaveChanges = (updatedReservation) => {
            // Save the updated facture here (you can either update it locally or make an API call)
            setReservations((prevReservations) =>
                prevReservations.map((reservation) =>
                reservation.id_reservation === updatedReservation.id_reservation ? updatedReservation : reservation
              )
            );
            setIsEditModalOpen(false); // Close the modal
          };

    


    
  const printReservation = (Reservation) => {
    handlePrint({
      ...Reservation,
      clients: Reservation.clients,
    });
  };





    const fetchData = async () => {
        setLoading(true);
        setError(null); 

        try {
            const params = new URLSearchParams();
            Object.keys(filters).forEach(key => {
                if (filters[key]) {
                    params.append(key, filters[key]);
                }
            });

            const reservationsRes = await fetch(`${apiUrl}/api/detail/reservation?${params.toString()}`, {
                    headers: { 'Authorization': `Bearer ${token}` },
            });
            if (!reservationsRes.ok ) {
                throw new Error("Failed to fetch data");
            }
            const reservationsData = await reservationsRes.json();

            if(reservationsData.length > 0){
                setCurrentPage(1);
            }


            setReservations(reservationsData);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };






      function formatTimestamp(timestamp) {
        const date = new Date(timestamp);
      
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
      
        return `${day}/${month}/${year}  ${hours}:${minutes}`;
      }
      



    
    const handleSearchClick = () => {
        fetchData();
    };



    useEffect(() => {
        fetchData();
    }, []);


    const handlesubmit = () => {
        fetchData();
    };


        // Handle change Montant_achat field
        const handleRowsPageChange = (e) => {
            let value = e.target.value;
             setRowsPage(value);
        };

    


        const paginateData = useMemo(() => {
                    const sortedReservations = [...reservations].sort((a, b) => {
                        return new Date(b.createdAt) - new Date(a.createdAt);
                    });
                
                    const startIndex = (currentPage - 1) * rowspage;
                    const endIndex = startIndex + parseInt(rowspage);
                    return sortedReservations.slice(startIndex, endIndex);
        }, [reservations, currentPage, rowspage]);



    // Handle pagination buttons (Next, Prev, etc.)
    const totalPages = Math.ceil(reservations.length / rowspage);
    const goToPage = (page) => setCurrentPage(page);

    // Disable Prev/Next if no data
    const isPrevDisabled = currentPage === 0 || currentPage === 1 || reservations.length === 0;
    const isNextDisabled = currentPage === totalPages || reservations.length === 0;

    if (loading) {
        return (
            <div className="loader">
                <div className="spinner"></div>
            </div>
        );
    }

    if (error) {
        return <div className='Facturetablie__ErrorAPI'>Error: {error}</div>;
    }

    // Action handlers
    const exportTableInExcel = () => exportReservationExcel(reservations);

    return (
        <div className="Facturetablie">
    <h2 className="Facturetablie__title">Liste nominative des reservation réalisées</h2>

    <div className="Facturetablie__filterSection1">
        <div className='Facturetablie__SearchDtate'>
            <div className="Facturetablie__filterGroup">
                <label htmlFor="startDate">Start Date</label>
                <input
                   type="date"
                   id="startDate"
                   className="Facturetablie__filterInput"
                   name="startDate"
                   value={filters.startDate}
                   onChange={handleFilterChange}
                />
            </div>
            <div className="Facturetablie__filterGroup">
                <label htmlFor="endDate">End Date</label>
                <input
                   type="date"
                   id="endDate"
                   className="Facturetablie__filterInput"
                   name="endDate"
                   value={filters.endDate}
                   onChange={handleFilterChange}
                />
            </div>
        </div>
        <div className='Facturetablie__filterSection'>
    {['id_reservation','organisme', 'hotel', 'room', 'pension', 'passport','clientName', 'checkInDate', 'checkOutDate', 'BCReference', 'reservationStatus'].map((filter, index) => (
        <div 
            className="Facturetablie__filterGroup1" 
            key={index}
        >
            <label htmlFor={filter}>{filter}</label>
            <input
                className="Facturetablie__filterInput"
                type={filter === 'checkInDate' || filter === 'checkOutDate' ? 'date' : 'text'}
                name={filter}
                id={filter}
                value={filters[filter]}
                onChange={handleFilterChange}
                placeholder='filter'
            />
        </div>
    ))}
</div>

        <button className="Facturetablie__searchButton" onClick={handleSearchClick}>Search</button>
    </div>

    <div className="Facturetablie__exportation">
        <button className="Facturetablie__exportButton" onClick={exportTableInExcel}>Exporter en Excel</button>
    </div>



    {/* Pagination */}
    <div className='Facturetablie__paginationarea'>
        <div className="Facturetablie__pagination">
           <button disabled={isPrevDisabled} onClick={() => goToPage(currentPage - 1)}>&lt; Prev</button>
           <span>Page {currentPage} of {totalPages}</span>
           <button disabled={isNextDisabled} onClick={() => goToPage(currentPage + 1)}>Next &gt;</button>

           <input
            type="text"
            className="Facturetablie__rowspage"
            value={rowspage}
            onChange={handleRowsPageChange}
        />
        </div>
    </div>

            <table className="Facturetablie__table">
                <thead>
                    <tr className="Facturetablie__headerRow">
                        {[
                            { name: "date", label: "Date" },
                            { name: "organisme", label: "Organisme" },
                            { name: "hotel", label: "Hôtel" },
                            { name: "room", label: "Room" },
                            { name: "id_reservation", label: "N reservation" },
                            { name: "pension", label: "Pension" },
                            { name: "updatedAt", label: "mise à jour" },
                            { name: "observations", label: "Observations" },
                            { name: "passport", label: "Passport" },
                            { name: "clientName", label: "Résident" },
                            { name: "checkInDate", label: "Check-In" },
                            { name: "checkOutDate", label: "Check-Out" },
                            { name: "BCReference", label: "BCReference" },
                            { name: "reservationStatus", label: "Statut" },
                            { name: "updatedAtt", label: "mise à jour clients" },
                            
                        ].map(({ name, label}) => (
                            <th key={name}>{label}</th>
                        ))}
                        <th>Actions</th>
                    </tr>
                </thead>

                <tbody>
                    {paginateData.length > 0 ? (
                        paginateData.map((item) =>
                                item.clients.map((client, index) => (
                                    <tr key={`${item.id_facture}-${index}`}>
                                        {index === 0 && (
                                            <>
                                                <td rowSpan={item.clients.length}>{formatedDateClient(item.currentDate)}</td>
                                                <td rowSpan={item.clients.length}>{item.selectedorganisme}</td>
                                                <td rowSpan={item.clients.length}>{item.selectedHotel}</td>
                                                <td rowSpan={item.clients.length}>{item.selectedRoom}</td>
                                                <td rowSpan={item.clients.length}>{item.id_reservation}</td>
                                                <td rowSpan={item.clients.length}>{item.pension}</td>
                                                <td rowSpan={item.clients.length}>{formatTimestamp(item.updatedAt)}</td>
                                                <td rowSpan={item.clients.length} style={{ width: '100px', wordWrap: 'break-word', whiteSpace: 'normal' }}> {item.observations} </td>
                                            </>
                                        )}
                                        <td>{client.passport}</td>
                                        <td>{client.clientName}</td>
                                        <td>{formatedDateClient(client.checkInDate)}</td>
                                        <td>{formatedDateClient(client.checkOutDate)}</td>
                                        <td>{client.BCReference}</td>
                                        <td>{client.reservationStatus}</td>
                                        <td>{formatTimestamp(client.updatedAt)}</td>
                                        <td className='Facturetablie__buttonarea'>
                                          <div className="action-buttons"> 
                                            <button 
                                              className="facturesContainer__printButton" 
                                              onClick={() => printReservation(item)}
                                            >
                                              Print
                                            </button>
                                            <button 
                                              className="facturesContainer__editFacture" 
                                              onClick={() => editReservation(item.id_reservation)}>
                                              Edit
                                            </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                        )
                    ) : (
                        <tr><td colSpan="16" className='not-found'>No results found.</td></tr>
                    )}
                </tbody>
            </table>

    {isEditModalOpen && (
        <EditReservations
          reservations={selectedReservation}
          onClose={() => setIsEditModalOpen(false)}
          isSubmited={handlesubmit}
        />
    )}
</div>

    );
};

export default ReservationsTable;